<script lang="ts" setup>
  import { FlowLoaderWidget } from '@/widgets/Flow'
  import { useRouter } from 'vue-router'
  import { inject, onMounted, type ComputedRef } from 'vue'
  import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
  import FlowWidget from '@/widgets/Flow/FlowWidget/FlowWidget.vue'
  import { useHomeUrl } from '@/shared/composables/useHomeUrl'
  import { TravelDirection } from '@/shared/types/common.types'

  interface Props {
    variant?: TravelDirection | null
  }

  const props = defineProps<Props>()
  const isRTL = inject('isRTL') as ComputedRef<boolean>
  const { getHomeUrl } = useHomeUrl()
  const homeUrl = getHomeUrl()

  const { push } = useRouter()

  onMounted(() => {
    if (props.variant === TravelDirection.INBOUND) {
      push({ name: InboundFlowRoutes.QUOTE })
    } else if (props.variant === TravelDirection.OUTBOUND) {
      push({ name: OutboundFlowRoutes.QUOTE })
    } else {
      window.location.href = homeUrl
    }
  })
</script>

<template>
  <FlowWidget :with-arrow-back="false" :steps-count="1" :is-rtl="isRTL" :current-step="1">
    <FlowLoaderWidget />
  </FlowWidget>
</template>
